import React from "react";


const CloseIcon = props => {

    return (
        <svg id="Group_422" data-name="Group 422" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
            <g id="Ellipse_18" data-name="Ellipse 18" fill="#fff" stroke="#707070" stroke-width="1.5">
                <circle cx="11" cy="11" r="11" stroke="none" />
                <circle cx="11" cy="11" r="10.25" fill="none" />
            </g>
            <g id="Group_221" data-name="Group 221" transform="translate(10.734 3.097) rotate(45)">
                <line id="Line_81" data-name="Line 81" y2="10.8" transform="translate(5.4 0)" fill="none" stroke="#707070" stroke-width="1.5" />
                <line id="Line_82" data-name="Line 82" y2="10.8" transform="translate(10.8 5.4) rotate(90)" fill="none" stroke="#707070" stroke-width="1.5" />
            </g>
        </svg>
    );

}

export default CloseIcon;